/**
 * Route for `igaming-brand-level-reporting-isolation`. Registered via createRoute; root wires into router.tsx.
 */
import { createRoute } from "@tanstack/react-router";
import { rootRoute } from "../routes/__root";
import { IgamingBrandLevelReportingIsolationPage } from "../features/igaming-brand-level-reporting-isolation/IgamingBrandLevelReportingIsolationPage";

export const igamingBrandLevelReportingIsolationRoute = createRoute({
	getParentRoute: () => rootRoute,
	path: "/igaming-brand-level-reporting-isolation",
	component: IgamingBrandLevelReportingIsolationPage,
});

export default igamingBrandLevelReportingIsolationRoute;
